import React from "react";

import Checklist from './checklist.jsx';


class ChecklistPage extends React.Component {

    render(){
        return (
            <div>
                <Checklist type="pre_mission" title="Pre-mission checklist"/>
                <div style={{height: 30}}/>
                <Checklist type="post_mission" title="Post-mission checklist"/>
            </div>
        )
    }
}

export default ChecklistPage;